import api from './client';
import type { Connector, ConnectorCategory } from './types';

export const connectorsService = {
  /**
   * Get all connector categories
   */
  getCategories: async (): Promise<ConnectorCategory[]> => {
    return api.get<ConnectorCategory[]>('/connectors/categories');
  },

  /**
   * Get all connectors, optionally filtered by category
   */
  getConnectors: async (category?: string): Promise<Connector[]> => {
    const endpoint = category
      ? `/connectors?category=${encodeURIComponent(category)}`
      : '/connectors';

    return api.get<Connector[]>(endpoint);
  },

  /**
   * Get connector by ID
   */
  getConnectorById: async (id: string): Promise<Connector> => {
    return api.get<Connector>(`/connectors/${id}`);
  },
};

export default connectorsService;